export default "__VITE_ASSET__DDH4Nne___"